export enum GlobalModalTypesEnum {
  WORK_ORDER_TYPE = "work-order",
}
